//////// POINTS MAP EXAMPLE ///////////////////////

// for mobile view - bound to LA city
// export const BOUNDS_SMALL = [-118.965411, 33.72144,-117.81778, 34.285528];
// // for desktop view - bound to LA city - WSEN
// export const BOUNDS_LARGE = [-119.25658, ,33.5024226, -116.841974, 34.29202];

//////// SHAPES MAP EXAMPLE ////////////////////////////////////
export const BOUNDS_SMALL = [-119.2476, 34.782, -118.3498, 33.8869];
export const BOUNDS_LARGE = [-119.2846, 34.8936, -116.6276, 33.3166];

export const STYLE = `mapbox://styles/latimes/cm36dzgiz011i01pwfkgj57b5${
  process.env.NODE_ENV === 'development' ? '/draft' : ''
}`;
export const TILESET = 'mapbox://latimes.sce_psps_20241106';
export const SOURCE_LAYER = 'areas';
export const SOURCE = 'source';
export const TOKEN =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';
